import React, { HTMLInputTypeAttribute, useState } from 'react';

import I18n from '~/src/common/services/I18n';
import { noop } from '~/src/common/utils/function';

import { HideTextButton, StyledInput } from './layout';

type Props = Omit<React.ComponentProps<typeof StyledInput>, 'onChange'> & {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: HTMLInputTypeAttribute;
};

const Input = React.forwardRef(
  (
    { onChange = noop, type: initialInputType, ...props }: Props,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    const [inputType, setInputType] = useState<HTMLInputTypeAttribute>(initialInputType ?? 'text');

    const handleHideTextClick = () => {
      setInputType(prevState => (prevState === 'password' ? 'text' : 'password'));
    };

    return (
      <>
        <StyledInput {...props} onChange={onChange} ref={ref} type={inputType} />
        {initialInputType === 'password' ? (
          <HideTextButton
            icon={inputType === 'password' ? 'eye-off' : 'eye-on'}
            label={I18n.t(
              `validation.${inputType === 'password' ? 'show' : 'hide'}-password-aria-label`,
            )}
            onClick={handleHideTextClick}
            variant="transparent"
            aria-hidden="true"
          />
        ) : null}
      </>
    );
  },
);

export default Input;
